
import React, { SVGProps } from 'react';

const SvgVideoIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none" {...props}>
            <rect width="21.8182" height="18.8565" rx="4" fill="#4C80FF" />
            <path d="M14.3545 9.42825L9.61765 13.5108L9.61765 5.34569L14.3545 9.42825Z" fill="white" />
        </svg>
    );
}

export default SvgVideoIcon;